import { debounce } from '@chatwoot/utils';
import { captureConversationSession } from 'dashboard/permissionSets/conversationReads';

export const createReplyDraftAutosave = store => {
  const isCurrentSession = captureConversationSession({
    rootState: store.state,
    rootGetters: store.getters,
  });
  let pending;
  const flush = () => {
    const snapshot = pending;
    pending = null;
    if (snapshot && isCurrentSession()) {
      store.dispatch('draftMessages/set', snapshot);
    }
  };
  const autosave = debounce(
    snapshot => {
      if (pending === snapshot) flush();
    },
    500,
    true
  );
  return {
    schedule(snapshot) {
      pending = snapshot;
      autosave(snapshot);
    },
    flush,
  };
};
